module.exports = __webpack_public_path__ + "static/img/woman1.7079254.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HumanPic/woman1.png
// module id = SWHh
// module chunks = 2